(($) => $(document).tooltip({
  selector: '.tt'
}))(jQuery);
